import React, { useState } from 'react';
import { Pressable, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';

const ShowMore = ({ text, maxLines = 3 }) => {
  const { styles, theme } = useStyles(stylesheet);

  const [expanded, setExpanded] = useState(false);

  const handlePress = () => {
    setExpanded(!expanded);
  };

  return (
    <View style={styles.container}>
      <View style={styles.textContainer}>
        <Text
          type="bodyRegular"
          numberOfLines={expanded ? undefined : maxLines}
          ellipsizeMode="tail"
          style={{ color: theme.colors.text.secondary }}
        >
          {text}
        </Text>
      </View>

      <Pressable onPress={handlePress} style={styles.button}>
        <Text type="bodyRegular" style={{ color: theme.colors.text.secondary }}>
          {expanded ? 'Show less' : 'Show more'}
        </Text>
      </Pressable>
    </View>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  container: { gap: 8 },
  textContainer: {
    position: 'relative',
  },
  button: {
    alignItems: 'center',
  },
}));

export default ShowMore;
